import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PasswordIcon from '@mui/icons-material/Password';
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import headerimage from '../../images/headerlogin.png';
import '../../css/Login.css'
import { message } from "antd";
import { useDispatch } from "react-redux";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import { setUser } from "../../Redux/Reducers/authSlice";
import { useState } from "react";
import { postRequest } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";


export default function SignIn() {


  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');


  const doLogin = async () => {

    if (!username) return message.error('Please enter email');
    if (!password) return message.error('Please enter password');

    const body = {
      email: username,
      password: password,
      type: 'admin'
    }

    dispatch(setLoader(true))
    const onSuccess = (res) => {
      // console.log('the res',res)
      // return;
      dispatch(setLoader(false));
      const userData = {
        ...res.data,
        loginDateTime: new Date()
      }
      dispatch(setUser(userData));
      return;
    }

    const onError = (res) => {
      res?.data?.error && alert(res?.data?.error);
      dispatch(setLoader(false));
    }

    await postRequest(body, apiRoutes.login, onSuccess, onError);

  }




  return (
    <div className="Login">
      <Container component="main" maxWidth="xs" sx={{ justifyContent: 'center', backgroundColor: 'white', paddingBottom: '20px', boxShadow: '1px 1px 10px 1xpx' }} >
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* <Avatar sx={{ m: 1, bgcolor: "success.main" }}> */}
          {/* <PasswordIcon /> */}
          <Container>
            <div style={{ display: 'flex', justifyContent: 'center', }}>
              <img
                src={headerimage}
                alt="Header Image"
                style={{ width: '80%', marginTop: '20px' }}
              />
            </div>
          </Container>
          {/* </Avatar> */}
          {/* <Typography component="h1" variant="h5">
          Login
        </Typography> */}
          <Box component="form" noValidate sx={{ mt: 1 }}>
            <TextField
              sx={{ fontFamily: 'Poppins' }}
              margin="normal"
              required
              fullWidth
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              onChange={(e) => setUsername(e.target.value)}

            />
            <TextField
              sx={{ fontFamily: 'Poppins' }}
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)}

            />
            {/* <FormControlLabel
             sx={{fontFamily:'Poppins'}}
            control={<Checkbox value="remember" color="primary" />}
            label={
                <Typography sx={{ fontFamily: 'Poppins' }}>
                  Remember me
                </Typography>
            }
          /> */}
            {/* <Link href="teacherdashboard" variant="body2"> */}
            <Button
              onClick={() => doLogin()}
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, fontFamily: 'Poppins', fontWeight: '600' }}
            >
              LOGIN
            </Button>
            {/* </Link> */}

          </Box>
        </Box>
      </Container>
    </div>
  );


}